import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { MonitoringStatus } from 'enum'

export const useCourseStatus = () => {
  const { t } = useTranslation()

  const courseStatus = useCallback(
    (state: MonitoringStatus) => {
      const states = {
        [MonitoringStatus.Pending]: t('components.courseCard.stateUnstarted'),
        [MonitoringStatus.InProgress]: t(
          'components.courseCard.stateInProgress'
        ),
        [MonitoringStatus.Finish]: t('components.courseCard.stateFinished'),
      }

      return states[state]
    },
    [t]
  )

  return courseStatus
}
